import AnalyticsService, { BillingEventNameAMP, EventNameAMP } from 'application/services/AnalyticsService';
import { PointWithDevice } from 'application/presenters/point/types';

import {
  CURRENT_POINT_KEY,
  INACTIVE_STATUS_VALUE,
  IS_NEED_REDIRECT_TO_SOURCE_FROM_KEY,
  IS_NEED_SHOW_LICENSES_MODAL,
  PERSISTED_LICENSES_KEY,
} from './consts';
import { LicensesModalState } from './types';

export const sendEvent = (unpaidLicensesOnly: boolean, isNeedPayment: boolean) => {
  if (unpaidLicensesOnly) {
    AnalyticsService.event(EventNameAMP.BILLING_UNPAID_LICENSES_PAY_CLICKED);
  } else {
    const submitEventName = isNeedPayment
      ? BillingEventNameAMP.PAYMENT_MODAL_SUBMIT_PAYMENT
      : BillingEventNameAMP.PAYMENT_MODAL_SUBMIT_CONFIRM;

    AnalyticsService.event(submitEventName);
  }
};

export const persistToEnableLicenses = (state: LicensesModalState) => {
  const persistedState = JSON.stringify(state);
  localStorage.setItem(PERSISTED_LICENSES_KEY, persistedState);
  localStorage.setItem(IS_NEED_SHOW_LICENSES_MODAL, 'true');
};

export const persistCurrentPoint = (currentPoint: PointWithDevice) => {
  localStorage.setItem(IS_NEED_REDIRECT_TO_SOURCE_FROM_KEY, INACTIVE_STATUS_VALUE);
  localStorage.setItem(CURRENT_POINT_KEY, JSON.stringify(currentPoint));
};
